import React, { useState } from "react";
import CustomModal from "../Common/CustomModal";
import { East } from "@mui/icons-material";
import { Box, Grid2, Typography } from "@mui/material";
import CustomSlider from "../Common/CustomSlider";
import { CustomInput, CustomTextArea } from "../Common/CustomInputs";
import axiosInstance from "../../utils/config/config";
import { colors } from "../../theme/theme";
import {
  CustomDropdown,
  CustomMultiSelectDropdown,
} from "../Common/CustomDropdown";

const PractitionerModal = ({
  open,
  handleClose,
  setloading,
  setsuccess,
  seterrorState,
  setSessionComp,
}) => {
  const [formData, setFormData] = useState({
    fullName: "",
    expertise: [],
    gender: "",
    status: "",
    numOfTraining: 0,
    description: "",
    lookingForGender: [],
    lookingForStatus: "",
    lookingForNumOfTraining: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const onSubmit = async () => {
    seterrorState({ error: false, errorMsg: "" });

    if (!formData.fullName || !formData.numOfTraining) {
      seterrorState({ error: true, errorMsg: "Please fill all the fields" });
      return;
    }

    try {
      setloading(true);
      const response = await axiosInstance.post("sessionexchange/create", {
        name: formData.fullName,
        gender: formData.gender,
        status: formData.status,
        numOfTrainings: formData.numOfTraining,
        description: formData.description,
        lookingForGender: formData.lookingForGender,
        lookingForStatus: formData.lookingForStatus,
        lookingForNumOfTrainings: formData.lookingForNumOfTraining,
      });

      if (response.data) {
        setsuccess(true);
        setSessionComp("setupsession");
        setFormData({
          fullName: "",
          expertise: [],
          numOfTraining: 0,
          description: "",
          gender: "",
          status: "",
          lookingForGender: [],
          lookingForStatus: "",
          lookingForNumOfTraining: 0,
        });
      }
      setloading(false);
    } catch (error) {
      setloading(false);
      seterrorState({ error: true, message: error.message });
    } finally {
      setloading(false);
      handleClose();
    }
  };

  return (
    <CustomModal
      open={open}
      handleClose={handleClose}
      title={"practitioner"}
      saveBtnText={"Submit"}
      saveIcon={East}
      onSave={() => {
        handleClose();
        onSubmit();
      }}
      onCancel={() => {
        setFormData({
          fullName: "",
          expertise: [],
          numOfTraining: 0,
        });
        // handleClose();
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: 4,
          py: 2,
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 item size={{ xs: 12 }}>
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "'Gotham', sans-serif",
                fontSize: "16px",
                my: 2,
              }}
            >
              My Details:
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 12 }}>
            <CustomInput
              label={"Full Name"}
              placeholder={"E.G Williams"}
              value={formData.fullName}
              setValue={(value) =>
                handleChange({ target: { name: "fullName", value } })
              }
              noIcon
              smallBr
              bR={"14px"}
              width={"100%"}
              color={colors.primary}
            />
          </Grid2>

          <Grid2 item size={{ xs: 6 }}>
            <CustomDropdown
              value={formData.gender}
              setValue={(value) =>
                handleChange({ target: { name: "gender", value } })
              }
              label="Gender"
              data={[
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
                { label: "Other", value: "Other" },
              ]}
              noIcon
              placeholder="Select Gender"
              color={colors.primary}
            />
          </Grid2>

          <Grid2 item size={{ xs: 6 }}>
            <CustomDropdown
              value={formData.status}
              setValue={(value) =>
                handleChange({ target: { name: "status", value } })
              }
              label="Educational Status"
              data={[
                { label: "Student", value: "Student" },
                { label: "Graduate", value: "Graduate" },
              ]}
              noIcon
              placeholder="Select Status"
              color={colors.primary}
            />
          </Grid2>

          <Grid2 item size={{ xs: 12 }}>
            {/* Slider */}
            <CustomSlider
              label="Number of Training hours"
              value={formData.numOfTraining}
              max={1000}
              setValue={(value) =>
                handleChange({ target: { name: "numOfTraining", value } })
              }
            />
          </Grid2>

          <Grid2 item size={{ xs: 12 }}>
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "'Gotham', sans-serif",
                fontSize: "16px",
                mb: 2,
                mt: 4,
              }}
            >
              Looking for:
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 6 }}>
            <CustomMultiSelectDropdown
              value={formData.lookingForGender}
              setValue={(value) =>
                handleChange({ target: { name: "lookingForGender", value } })
              }
              label="Gender"
              data={[
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
                { label: "Other", value: "Other" },
              ]}
              noIcon
              placeholder="Select Gender"
              color={colors.primary}
            />
          </Grid2>

          <Grid2 item size={{ xs: 6 }}>
            <CustomDropdown
              value={formData.lookingForStatus}
              setValue={(value) =>
                handleChange({ target: { name: "lookingForStatus", value } })
              }
              label="Educational Status"
              data={[
                { label: "Student", value: "Student" },
                { label: "Graduate", value: "Graduate" },
              ]}
              noIcon
              placeholder="Select Status"
              color={colors.primary}
            />
          </Grid2>

          <Grid2 item size={{ xs: 12 }}>
            {/* Slider */}
            <CustomSlider
              label="Number of Training hours"
              value={formData.lookingForNumOfTraining}
              max={1000}
              setValue={(value) =>
                handleChange({
                  target: { name: "lookingForNumOfTraining", value },
                })
              }
            />
          </Grid2>

          <Grid2 item size={{ xs: 12 }}>
            <CustomTextArea
              label="Description"
              placeholder="Reason for seeking a hypnotherapy session. Feel free to be general to protect your confidentiality as this form is seen by other users."
              value={formData.description}
              setValue={(value) =>
                handleChange({ target: { name: "description", value } })
              }
              noIcon
              smallBr
              bR={"14px"}
              width={"100%"}
              color={colors.primary}
            />
          </Grid2>
          {/* Practitioner Fields */}
          {/* <Grid2 item xs={12} sm={12}>
            {(formData.field1 &&
              formData.field2 &&
              ghlUserData?.contact?.tags?.includes(
                "approved member directory"
              )) ||
            showPractitionerFields ? (
              <>
                <Typography
                  sx={{
                    color: colors.primary,
                    fontFamily: "'Quicksand', sans-serif",
                    fontSize: "14px",
                    mt: 2,
                    mb: 1,
                  }}
                >
                  {practitionerStatus ? (
                    <div>
                      Practitioner Status:{" "}
                      <span style={{ color: "green" }}>Approved</span>
                    </div>
                  ) : (
                    <div>
                      Practitioner Status:{" "}
                      <span style={{ color: "red" }}>Pending</span>
                    </div>
                  )}
                </Typography>

                <Grid2 item xs={12}>
                  <Typography
                    sx={{
                      fontFamily: "'Gotham', sans-serif",
                      fontSize: { xs: "16px", sm: "18px" },
                      color: colors.primary,
                      textAlign: "left",
                      mt: 2,
                    }}
                  >
                    Practitioner Info
                  </Typography>
                </Grid2>

                <Grid2 item xs={12} sm={6}>
                  <CustomInput
                    value={formData.field1}
                    setValue={(value) =>
                      handleChange({ target: { name: "field1", value } })
                    }
                    placeholder="enter text 1"
                    label="Field 1"
                    smallBr
                    bR="14px"
                    width="100%"
                    noIcon
                    iconColor="red"
                    color={colors.primary}
                  />
                </Grid2>
                <Grid2 item xs={12} sm={6}>
                  <CustomInput
                    value={formData.field2}
                    setValue={(value) =>
                      handleChange({ target: { name: "field2", value } })
                    }
                    placeholder="enter text 2"
                    label="Field 2"
                    smallBr
                    bR="14px"
                    width="100%"
                    noIcon
                    iconColor="red"
                    color={colors.primary}
                  />
                </Grid2>
              </>
            ) : (
              memberDirectoryStatus &&
              !formData.field1 &&
              !formData.field2 && (
                <CustomBtn
                  width={"100%"}
                  text="Become a Practitioner"
                  onClick={() => setShowPractitionerFields(true)}
                  Icon={UploadOutlined}
                  noIcon
                />
              )
            )}
          </Grid2> */}
        </Grid2>
      </Box>
    </CustomModal>
  );
};

export default PractitionerModal;
